import { FC } from 'react'

import { Modal } from '@tribeplatform/react-ui-kit/Modal'
import { Tabs } from '@tribeplatform/react-ui-kit/Tabs'

import { T } from '../../../i18n/index.js'
import { ShareLink, ShareLinkType } from '../../../ShareModal/ShareLink.js'

import { EventEmbedCreator } from './EventEmbedCreator.js'

export type ShareModalProps = ShareLinkType & {
  open: boolean
  onClose: () => void
  eventId: string
}

export const ShareModal: FC<ShareModalProps> = ({
  open,
  onClose,
  isPrivate,
  url,
  title,
  eventId,
}) => {
  return (
    <Modal
      showZenModeBtn
      open={open}
      onClose={onClose}
      className="inline-flex flex-col sm:m-0"
    >
      <Tabs.Group>
        <Modal.Header>
          <Tabs.List variant="filled">
            <Tabs.Tab>
              <T defaultMessage="Share" id="Generics.Share" />
            </Tabs.Tab>

            <Tabs.Tab>
              <T defaultMessage="Embed" id="Generics.Embed" />
            </Tabs.Tab>
          </Tabs.List>
        </Modal.Header>

        <Modal.Content
          padding={false}
          className="px-4 sm:px-6 pb-6 pt-1 w-full mx-auto overflow-auto"
        >
          <Tabs.Panels>
            <Tabs.Panel>
              <ShareLink url={url} title={title} isPrivate={isPrivate} />
            </Tabs.Panel>

            <Tabs.Panel>
              <EventEmbedCreator eventId={eventId} />
            </Tabs.Panel>
          </Tabs.Panels>
        </Modal.Content>
      </Tabs.Group>
    </Modal>
  )
}
